/**
 * Shares the current page through the native share sheet, falling back to copying
 * the URL when the browser has no Web Share API.
 * @param {string} title - title offered to the share sheet
 * @returns {Promise<boolean>} true when the URL was copied instead of shared
 */
export function sharePage(title){
  const url = window.location.href;

  if(navigator.share){
    return navigator.share({ title: title, url: url })
      .then(() => false)
      .catch(() => false);
  }

  return copyText(url).then(() => true).catch(() => false);
}

function copyText(text){
  if(navigator.clipboard && navigator.clipboard.writeText){
    return navigator.clipboard.writeText(text);
  }

  const input = document.createElement('input');
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand('copy');
  document.body.removeChild(input);
  return Promise.resolve();
}



// WEBPACK FOOTER //
// ./src/utils/share.js